<div class="dashboard-layout">
  <app-sidebar [hidden]="api.hide_on_print"></app-sidebar>
  <main class="dashboard-layout__content">
    <app-navbar [hidden]="api.hide_on_print"></app-navbar>
    <section class="dashboard-layout__body">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
